import {
  GatewayAvancement,
  GatewayConformiteRcPro,
  GatewayEntreprise,
  GatewayInfoSocieteOrias,
} from "@conformite/gateway";
import { MaxWidthContent, TagConformite, Card } from "@endya-conformite/ui-kit";
import { ConformiteSocieteActions } from "@src/conformite/societeActions/ConformiteSocieteActions";
import styles from "../ConformiteRcPro.module.scss";
import { ConformiteRcProForm } from "./ConformiteRcProForm";
import { useConformiteRcProEdit } from "./useConformiteRcProEdit";

type ConformiteRcProEditProps = {
  siren: string;
  isConforme: boolean;
  millesime: number;
  categorie: GatewayInfoSocieteOrias.Categorie;
  rcPro: GatewayConformiteRcPro.ConformiteRcProProperty | null;
  stopEditing: (
    value?: GatewayConformiteRcPro.ConformiteRcProProperty,
    avancement?: GatewayAvancement.AvancementSociete
  ) => void;
  societe: GatewayEntreprise.EntrepriseAControllerResponseType;
};

export function ConformiteRcProEdit({
  siren,
  isConforme,
  millesime,
  stopEditing,
  rcPro,
  categorie,
  societe,
}: ConformiteRcProEditProps) {
  const {
    properties,
    formConfig,
    onSubmit,
    hasRcpIndividuelleSouscritSetToNo,
  } = useConformiteRcProEdit(
    siren,
    millesime,
    categorie,
    rcPro,
    stopEditing,
    societe
  );
  return (
    <MaxWidthContent size="large" className={styles.contentEditable}>
      <Card className={styles.content}>
        <div className={styles.cardHeaderLeft}>
          <h3>Formulaire</h3>
          <TagConformite isConforme={isConforme} year={millesime} isEditing />
        </div>
        <ConformiteRcProForm
          millesime={millesime}
          categorie={categorie}
          formConfig={formConfig}
          properties={properties}
          hasRcpIndividuelleSouscritSetToNo={hasRcpIndividuelleSouscritSetToNo}
          societe={societe}
        />
        <ConformiteSocieteActions
          onClick={() => {
            onSubmit(formConfig.getValues()).catch(console.error);
          }}
          isLoading={false}
          stopEditing={() => stopEditing()}
        />
      </Card>
    </MaxWidthContent>
  );
}
